import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login.vue'
import Home from '@/components/home/Home.vue'
import HomeMain from '@/components/home/HomeMain.vue'
import Applicant from '@/components/applicant/Applicant.vue'
import ApplicantUser from '@/components/applicant/ApplicantUser.vue'
import Expert from '@/components/expert/Expert.vue'
import ExpertGuide from '@/components/expert/ExpertGuide.vue'
import ExpertUser from '@/components/expert/ExpertUser.vue'
import ExpertSignPass from '@/components/expert/ExpertSignPass.vue'
import ProjectCategory from '@/components/projectCategory/ProjectCategory.vue'
import Coach from '@/components/coach/Coach.vue'
import CoachUser from '@/components/coach/CoachUser.vue'
import ProjectView from '@/components/project/ProjectView.vue'
import ProjectAdd from '@/components/project/ProjectAdd.vue'
import ProjectAudit from '@/components/project/ProjectAudit'
import ProjectAssess from '@/components/project/ProjectAssess.vue'
import ProjectDistribute from '@/components/project/ProjectDistribute'
import ProjectAssessAdmin from '@/components/project/ProjectAssessAdmin.vue'
import ProjectAssessCoach from '@/components/project/ProjectAssessCoach.vue'

import ProjectNewPid from '@/components/project/ProjectNewPid.vue'

import SignAgreement from '@/components/signAgreement/SignAgreement'
import AgreementAdminView from '@/components/signAgreement/AgreementAdminView'
import AgreementDistribute from '@/components/signAgreement/AgreementDistribute'
import CheckAgreement from '@/components/signAgreement/CheckAgreement'
import AgreementExpertView from '@/components/signAgreement/AgreementExpertView'
import AgreementFinanceView from '@/components/signAgreement/AgreementFinanceView'
import AgreementCoachView from '@/components/signAgreement/AgreementCoachView'

import MiddleCheckApplicant from '@/components/middleCheck/MiddleCheckApplicant'
import MiddleCheckAssessor from '@/components/middleCheck/MiddleCheckAssessor'
import MiddleCheckCoach from '@/components/middleCheck/MiddleCheckCoach'
import MiddleCheckFinance from '@/components/middleCheck/MiddleCheckFinance'
import MiddleCheckDistribute from '@/components/middleCheck/MiddleCheckDistribute'
import MiddleCheckAdmin from '@/components/middleCheck/MiddleCheckAdmin'
import MiddleCheckAdminView from '@/components/middleCheck/MiddleCheckAdminView'

import FinalApplicant from '@/components/finalCheck/FinalApplicant'
import FinalAssessor from '@/components/finalCheck/FinalAssessor'
import FinalCoach from '@/components/finalCheck/FinalCoach'
import FinalFinance from '@/components/finalCheck/FinalFinance'
import FinalAdmin from '@/components/finalCheck/FinalAdmin'
import FinalAdminView from '@/components/finalCheck/FinalAdminView'
import FinalDistribute from '@/components/finalCheck/FinalDistribute'

import Log from '@/components/admin/Log'
import SysDic from '@/components/admin/SysDic'
// 20230507 新增财务专家
import Finance from '@/components/finance/Finance.vue'
import FinanceUser from '@/components/finance/FinanceUser.vue'
import FinanceSignPass from '@/components/finance/FinanceSignPass.vue'
import ProjectAssessFinance from '@/components/project/ProjectAssessFinance.vue'
//20230726 新增首页，科研管理平台
import HomeList from '@/components/home/HomeList.vue'

//20241120 新增统计分析
import StatisticsSignAgreement from '@/components/statistics/StatisticsSignAgreement.vue'

// 测试数据与分析报告上传
import TestReportAdminView from '@/components/testReportUpload/TestReportAdminView.vue'
import TestReportUpload from '@/components/testReportUpload/TestReportUpload.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '课题管理系统-登录'
      }
    },
    {
      path: '/',
      name: '/',
      component: HomeList
    },
    // {
    //   path: '/',
    //   name: '/',
    //   component: Home
    // },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children: [{
          path: '/',
          name: 'homeMain',
          component: HomeMain
        },
        {
          path: '/applicant',
          name: 'applicant',
          component: Applicant
        },
        {
          path: '/applicantUser',
          name: 'applicantUser',
          component: ApplicantUser
        },
        {
          path: '/expert',
          name: 'expert',
          component: Expert
        },
        {
          path: '/expertGuide',
          name: 'expertGuide',
          component: ExpertGuide
        },
        {
          path: '/expertUser',
          name: 'expertUser',
          component: ExpertUser
        },
        {
          path: '/expertSignPass',
          name: 'expertSignPass',
          component: ExpertSignPass
        },
        {
          path: '/coach',
          name: 'coach',
          component: Coach
        },
        {
          path: '/coachUser',
          name: 'coachUser',
          component: CoachUser
        },
        {
          path: '/finance',
          name: 'finance',
          component: Finance
        },
        {
          path: '/financeUser',
          name: 'financeUser',
          component: FinanceUser
        },
        {
          path: '/financeSignPass',
          name: 'financeSignPass',
          component: FinanceSignPass
        },
        {
          path: '/projectCategory',
          name: 'projectCategory',
          component: ProjectCategory
        },
        {
          path: '/projectView',
          name: 'projectView',
          component: ProjectView
        },
        {
          path: '/projectAdd',
          name: 'projectAdd',
          component: ProjectAdd
        },
        {
          path: '/projectAudit',
          name: 'projectAudit',
          component: ProjectAudit
        }, {
          path: '/projectAssess',
          name: 'projectAssess',
          component: ProjectAssess
        }, {
          path: '/projectDistribute',
          name: 'projectDistribute',
          component: ProjectDistribute
        }, {
          path: '/projectAssessAdmin',
          name: 'projectAssessAdmin',
          component: ProjectAssessAdmin
        },
        {
          path: '/projectAssessCoach',
          name: 'projectAssessCoach',
          component: ProjectAssessCoach
        },
        {
          path: '/projectAssessFinance',
          name: 'projectAssessFinance',
          component: ProjectAssessFinance
        },{
          path: '/projectNewPid',
          name: 'projectNewPid',
          component: ProjectNewPid
        },
        {
          path: '/signAgreement',
          name: 'signAgreement',
          component: SignAgreement
        },
        {
          path: '/agreementAdminView',
          name: 'AgreementAdminView',
          component: AgreementAdminView
        },
        {
          path: '/agreementDistribute',
          name: 'agreementDistribute',
          component: AgreementDistribute
        },
        {
          path: '/checkAgreement',
          name: 'checkAgreement',
          component: CheckAgreement
        },
        {
          path: '/agreementFinanceView',
          name: 'agreementFinanceView',
          component: AgreementFinanceView
        },
        {
          path: '/agreementCoachView',
          name: 'agreementCoachView',
          component: AgreementCoachView
        },
        {
          path: '/agreementExpertView',
          name: 'agreementExpertView',
          component: AgreementExpertView
        },
        {
          path: '/testReportUpload',
          name: 'testReportUpload',
          component: TestReportUpload
        },
        {
          path: '/testReportAdminView',
          name: 'testReportAdminView',
          component: TestReportAdminView
        },
        {
          path: '/middleCheckApplicant',
          name: 'middleCheckApplicant',
          component: MiddleCheckApplicant
        },
        {
          path: '/middleCheckAssessor',
          name: 'middleCheckAssessor',
          component: MiddleCheckAssessor
        },
        {
          path: '/middleCheckFinance',
          name: 'middleCheckFinance',
          component: MiddleCheckFinance
        },
        {
          path: '/middleCheckCoach',
          name: 'middleCheckCoach',
          component: MiddleCheckCoach
        },
        {
          path: '/middleCheckDistribute',
          name: 'middleCheckDistribute',
          component: MiddleCheckDistribute
        },
        {
          path: '/middleCheckAdmin',
          name: 'middleCheckAdmin',
          component: MiddleCheckAdmin
        },
        {
          path: '/middleCheckAdminView',
          name: 'middleCheckAdminView',
          component: MiddleCheckAdminView
        },
        {
          path: '/finalApplicant',
          name: 'finalApplicant',
          component: FinalApplicant
        },
        {
          path: '/finalAssessor',
          name: 'finalAssessor',
          component: FinalAssessor
        },
        {
          path: '/finalCoach',
          name: 'finalCoach',
          component: FinalCoach
        },
        {
          path: '/finalFinance',
          name: 'finalFinance',
          component: FinalFinance
        },
        {
          path: '/finalAdmin',
          name: 'finalAdmin',
          component: FinalAdmin
        },
        {
          path: '/finalAdminView',
          name: 'finalAdminView',
          component: FinalAdminView
        },
        {
          path: '/finalDistribute',
          name: 'finalDistribute',
          component: FinalDistribute
        },
        //统计分析
        {
          path: '/statisticsSignAgreement',
          name: 'statisticsSignAgreement',
          component: StatisticsSignAgreement
        },
        {
          path: '/log',
          name: 'log',
          component: Log
        },
        {
          path: '/sysDic',
          name: 'sysDic',
          component: SysDic
        },
      ]
    },

  ]
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined ? '课题管理系统' : to.meta.title
  // 访问登录页，放行
  if (to.path === '/') return next()
  
  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = localStorage.getItem('token')
  // 没有token, 强制跳转到登录页
  if (!tokenStr) {
    return next('/login')
  }

  //如果手动输入地址，要检验是否在权限菜单列表中。不在menus里，强制跳转
  const menus = JSON.parse(localStorage.getItem("menus"))
  let ml = ['/home', '/login', '/']
  menus.data.forEach(item => {
    item.children.forEach(itemSub => {
      ml.push('/' + itemSub.path)
    })
  })
  const menuList = ml

  if (menuList.includes(to.path)) {
    next()
  } else {
    alert('没有权限')
    next('/login')
  }

})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js